import { jsx as _jsx } from "react/jsx-runtime";
import { FilePresentation } from './FilePresentation';
import { FolderPresentation } from './FolderPresentation';
import { CONTENT_TYPES } from '../types';
export const FileFolderPresentation = (props) => {
    const { description, displayFields, image, isLast, name, path, user } = props;
    if ('folderLabel' in props) {
        const { folderLabel } = props;
        return (_jsx(FolderPresentation, { contentType: CONTENT_TYPES.FOLDER, description: description, displayFields: displayFields, folderLabel: folderLabel, image: image, isLast: isLast, name: name, path: path, user: user }));
    }
    const { extension, fileType } = props;
    return (_jsx(FilePresentation, { contentType: CONTENT_TYPES.FILE, description: description, displayFields: displayFields, extension: extension, fileType: fileType, image: image, isLast: isLast, name: name, path: path, user: user }));
};
//# sourceMappingURL=FileFolderPresentation.js.map